import { callApi } from "./apiService";
import { videoCreatorEndPoint, webEndPoint } from "../Constants/constants";

export const fetchUserData = async (
  setUser,
  setDashboardData,
) => {
  try {
    const [profileRes, dashboardRes, languageRes] = await Promise.all([
      callApi(`${videoCreatorEndPoint}auth/me`, "GET"),
      callApi(`${videoCreatorEndPoint}contentDashboard/data`, "GET"),
    ]);

    if (profileRes?.status) {
      setUser(profileRes.data.creator);
    }

    if (dashboardRes?.status) {
      setDashboardData(dashboardRes.data);
    }
    if (dashboardRes?.status) {
      setDashboardData(dashboardRes.data);
    }

    return true;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return false;
  }
};